import { logout, logoutAndRedirect } from '../actions/auth'


export function checkHttpStatus(response) {
    if (response.status >= 200 && response.status < 300 || response.status == 422) {
        return response;
    } else {
        var error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
}

export function handleError(error, dispatch) {
    window.clearTimeout();
    window.setTimeout(()=>{
        dispatch(logoutAndRedirect());
    }, 100);
}

export function parseJSON(response) {
  return response.json()
}


/** WEBPACK FOOTER **
 ** ./js/utils/check-response.js
 **/